import {Enumeration} from './model/enumeration.model';

export class Locale implements Enumeration {

  private static ALL_VALUES: { [name: string]: Locale } = {};

  public static readonly ENGLISH = new Locale(1, 'en_US');
  public static readonly RUSSIAN = new Locale(2, 'ru_RU');
  public static readonly UKRAINE = new Locale(3, 'uk_UA');

  private constructor(readonly id: number, readonly name: string) {
    Locale.ALL_VALUES[id] = this;
  }
}
